import { reverseCardPayment, reverseTransfer, reverseDebtPayment } from '../../../ledger/reversals';
import type { LedgerResult } from '../../../ledger/ledger';
import type { LedgerEntry } from './entries';

export interface ReverseDialog { title: string; description: string; confirmLabel: string }

/** Lần trả nợ MỚI NHẤT của từng khoản vay (chỉ lần này đảo được). */
export const latestDebtPayments = (entries: LedgerEntry[]): Map<string, string> => {
  const best = new Map<string, LedgerEntry>();
  for (const e of entries) {
    if (e.kind !== 'debtPayment') continue;
    const debtId = e.raw.debtId ?? '';
    const cur = best.get(debtId);
    if (!cur || e.date.getTime() > cur.date.getTime()) best.set(debtId, e);
  }
  return new Map([...best].map(([k, v]) => [k, v.id]));
};

/** Nội dung hộp xác nhận cho từng loại; null = không đảo được (kèm lý do). */
export const reverseDialog = (e: LedgerEntry, latest: Map<string, string>): ReverseDialog | { blocked: string } => {
  if (e.kind === 'debtPayment' && latest.get(e.raw.debtId ?? '') !== e.id) {
    return { blocked: 'Chỉ hoàn tác được lần trả MỚI NHẤT của khoản vay này. Hoàn tác theo thứ tự từ mới đến cũ để không làm sai các kỳ sau.' };
  }
  if (e.kind === 'transfer') return { title: 'Hoàn tác chuyển khoản này?', description: 'Ví gửi nhận lại tiền (cả phí nếu có), ví nhận bị rút lại số đã nhận. Khoản phí tự sinh cũng được xoá. Không làm được nếu ví nhận đã dùng bớt số tiền đó.', confirmLabel: 'Hoàn tác chuyển khoản' };
  if (e.kind === 'cardPayment') return { title: 'Hoàn tác lần trả thẻ này?', description: 'Tiền hoàn lại ví đã trả, dư nợ thẻ tăng lại đúng số đó. Nếu lần trả đến từ một khoản dự kiến thì khoản đó mở lại ở mục Dự kiến.', confirmLabel: 'Hoàn tác trả thẻ' };
  return { title: 'Hoàn tác lần trả nợ này?', description: 'Tiền hoàn lại ví, dư nợ tăng lại theo phần gốc, khoản chi lãi tự sinh bị xoá. Nếu lần trả đến từ một khoản dự kiến thì khoản đó mở lại ở mục Dự kiến.', confirmLabel: 'Hoàn tác trả nợ' };
};

export const runReverse = (uid: string, e: LedgerEntry): Promise<LedgerResult> =>
  e.kind === 'transfer' ? reverseTransfer(uid, e.id)
    : e.kind === 'cardPayment' ? reverseCardPayment(uid, e.id)
      : reverseDebtPayment(uid, e.raw.debtId, e.id);
